import { UPDATE_CONVERSATION_ID, UPLOAD_FILE_FAILURE, UPLOAD_FILE_REQUEST, UPLOAD_FILE_SUCCESS } from './FileUploadType';

export interface FileUploadState {
    filename: string | null;
    url: string | null;
    external_source_document_id: string | null;
    conversation_id: string | null;
    loading: boolean;
    error: string | null;
}

export const initialState: FileUploadState = {
    filename: null,
    url: null,
    external_source_document_id: null,
    conversation_id: null,
    loading: false,
    error: null,
};

export const FileUploadReducer = (
    state = initialState,
    action: any
): FileUploadState => {
    switch (action.type) {
        case UPLOAD_FILE_REQUEST:
            return { ...state, loading: true, error: null };
        case UPLOAD_FILE_SUCCESS:
            return {
                ...state,
                filename: action.payload.filename,
                url: action.payload.url,
                external_source_document_id: action.payload.external_source_document_id,
                conversation_id: action.payload.conversation_id,
                loading: false,
                error: null,
            };
        case UPLOAD_FILE_FAILURE:
            return { ...state, loading: false, error: action.payload };   
        case UPDATE_CONVERSATION_ID:
            return { ...state, conversation_id: action.payload };
        default:
            return state;
    }
};